const visileColumns = [
  {
    title: "GENERAL AVAILIBILITY ID",
    field: "GENERAL_AVAILIBILITY_ID",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "POSITION",
    field: "POSITION",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
  {
    title: "Department Name",
    field: "DepartmentName",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
  {
    title: "Accepted Applicant",
    field: "Accepted_Applicant",
    locked: false,
    filter: "numeric",
    width: "180",
    show: true,
    className: "text-end",
    customFilterType: "CustomNumericText",
  },
  {
    title: "Rejected Applicant",
    field: "Rejected_Applicant",
    locked: false,
    filter: "numeric",
    width: "180",
    show: true,
    className: "text-end",
    customFilterType: "CustomNumericText",
  },
  {
    title: "Total Notify",
    field: "Total_Notify",
    locked: false,
    filter: "numeric",
    width: "180",
    show: true,
    className: "text-end",
    customFilterType: "CustomNumericText",
  },
  // {
  //   title: "Date Requested",
  //   field: "date_requested",
  //   locked: false,
  //   filter: "date",
  //   format: "MM/DD/YYYY",
  //   editor: "date",
  //   width: "180",
  //   show: true,
  // },
  // {
  //   title: "Date Executed",
  //   field: "date_executed",
  //   locked: false,
  //   filter: "date",
  //   format: "MM/DD/YYYY",
  //   editor: "date",
  //   width: "180",
  //   show: true,

  // },
  // {
  //   title: "Date Expires",
  //   field: "date_expires",
  //   locked: false,
  //   filter: "date",
  //   format: "MM/DD/YYYY",
  //   editor: "date",
  //   width: "180",
  //   show: true,
  // },
  // {
  //   title: "Start Date",
  //   field: "start_date",
  //   locked: false,
  //   filter: "date",
  //   format: "MM/DD/YYYY",
  //   editor: "date",
  //   width: "180",
  //   show: true,
  // },
  // {
  //   title: "End Date",
  //   field: "end_date",
  //   locked: false,
  //   filter: "date",
  //   format: "MM/DD/YYYY",
  //   editor: "date",
  //   width: "180",
  //   show: true,
  // },
];
  
  export default visileColumns;
  